import { ModalQueryStrings } from "@/Pages/Admin/editor/modals/types";
import { atom } from "jotai";

export const previouslyOpenedModalParamsAtom = atom<ModalQueryStrings | false>(false);
previouslyOpenedModalParamsAtom.debugLabel = "previouslyOpenedModalParamsAtom";
